import React from "react";
import { cn } from "../../../services/common/className";
import { TagColor } from "../../../app/data/common/tagColor";
import "./tag.scss";

export interface TagProps {
  children: any;
  mods?: {
    color?: TagColor;
    uppercase?: boolean;
    flex?: boolean;
  };
  mix?: string;
  onClick?: () => void;
  contrastMode?: boolean;
}

const Tag: React.FC<TagProps> = ({ mods, mix, children, contrastMode, onClick }) => {
  return (
    <div className={cn("tag")({ ...mods, "contrast-mode": contrastMode, clickable: !!onClick }, mix)} onClick={ onClick }>
      {children}
    </div>
  );
}

export default Tag;